import { RootState } from '@/app/store'
import { createDraftSafeSelector } from '@reduxjs/toolkit'

const selectSelf = (state: RootState) => state

export const appSelector = createDraftSafeSelector(selectSelf, (state) => state.app)
